// PARTNER-PORTÁL · JEGY-MELLÉKLET FELTÖLTÉS — a portál-specifikus KÉT végpont-hívás.
//
// A folyamat és a szabályok a KÖZÖS `lib/attachment-rules.ts`-ben élnek (ott a miért is); ez a modul CSAK azt
// mondja meg, MELYIK végpontra megy a presign és a commit. Ugyanaz a felosztás, mint a belső oldalon
// (`features/tickets/attachment-upload.ts`) — a partner végpontjai viszont a láthatósági magra épülnek, nem a
// `tickets.manage` feature-jogra.
//
// A TOAST-ok SZÁNDÉKOSAN nem itt vannak: a hívó dönti el, mit mond a felhasználónak.
import { api } from '@/lib/api';
import { runPresignedUpload, type AttachmentUploadOutcome } from '@/lib/attachment-rules';

/** Egyetlen fájl feltöltése a háromlépéses presigned-folyamattal. SOHA nem dob. */
export async function uploadPortalTicketAttachment(
  ticketId: string,
  file: File,
): Promise<AttachmentUploadOutcome> {
  return runPresignedUpload(file, {
    requestUrl: (body) =>
      api.portal.ticketAttachmentUploadUrl.mutation({ params: { id: ticketId }, body }),
    commit: (body) =>
      api.portal.ticketAttachmentCommit.mutation({ params: { id: ticketId }, body }),
  });
}
